import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
 
import zhLocale from "./zh";
import enLocale from "./en";
 
 
const messages = {
  zh: {
    ...zhLocale,
  },
  en: {
    ...enLocale
  }
}

let langue = localStorage.getItem('langue');
if(langue === null) {
  langue = 'zh';
  localStorage.setItem('langue', langue);
}

const i18n = new VueI18n({
  locale: langue,
  messages
});

// 添加全局方法用于动态计算字体大小
Vue.prototype.$getFontSize = function(baseSize) {
  // 如果当前语言是英文，字体大小减少4px
  return this.$i18n.locale === 'en' ? (baseSize - 4) : baseSize;
};

// 添加全局指令，方便在模板中直接使用
Vue.directive('font-size', {
  bind(el, binding, vnode) {
    const baseSize = binding.value || 16; // 默认16px
    const fontSize = vnode.context.$getFontSize(baseSize);
    el.style.fontSize = `${fontSize}px`;
  },
  update(el, binding, vnode) {
    const baseSize = binding.value || 16;
    const fontSize = vnode.context.$getFontSize(baseSize);
    el.style.fontSize = `${fontSize}px`;
  }
});
 
export default i18n;